1
<template>
  <div class="col-sm-12 animatedParent" role="main">
    <div class="animated xFadeInDown" data-id="1">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1357.9790879026448!2d18.65502108491149!3d49.663751411554756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDnCsDM5JzQ5LjUiTiAxOMKwMzknMjEuMyJF!5e1!3m2!1sen!2scz!4v1541969210347"
        width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
    </div>

    <clearfix :biggest="true"></clearfix>
  </div>
</template>

<script>
  import Clearfix from '@/components/utils/Clearfix'

  export default {
    components: {
      Clearfix
    }
  }
</script>



// WEBPACK FOOTER //
// FooterMap.vue?072d75f2